enum ProductCategoryEnum {
  SHAMPOO = "SHAMPOO",
  ORAL = "ORAL",
  LASER = "LASER",
}

export default ProductCategoryEnum;
